
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pizza/standard",
      function () {
        return require("private-next-pages/pizza/standard/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pizza/standard"])
      });
    }
  